@if (fieldsWidget) {
    <mvs-widget
            [widgetData]="fieldsWidget"
            (onObjectSelect)="onFieldSelect($event)"
    ></mvs-widget>
}
